import Vue from 'vue'
import App from './App.vue'
import router from './router'
import config from './config'
import '@/style/reset.css'
import '@/common/elementui.js'
import '@/style/public.scss'
import $ from 'jquery'
import ElementUI from 'element-ui';
import 'default-passive-events'
import store from './store'
import VueBus from 'vue-bus';
import request from './http/request.js'
import "@/utils/rem.js"
import *  as utils from "@/utils/utils.js"
import { pcconfig_api } from '@/http/api.js'
import NoData from "@/components/NoData"

const echarts = require('echarts');

Vue.use(VueBus);

Vue.component('NoData', NoData)

Vue.prototype.$echarts = echarts
Vue.prototype.$request = request
Vue.prototype.$ = $
Vue.prototype.$utils = utils

if (process.env.NODE_ENV === 'production') {
  Vue.config.productionTip = false
} else {
  Vue.config.productionTip = true
}

Vue.prototype.$config = config

//防止ElementUI。Dialog滚动条出现而导致页面抖动
ElementUI.Dialog.props.lockScroll.default = false;

router.beforeEach(async (to, from, next) => {


  // 获取配置信息
  const res = await pcconfig_api()
  localStorage.setItem('pcconfig', JSON.stringify(res.data))

  let login_type = localStorage.getItem('login_type') + ''
  let access_token = localStorage.getItem('access_token')
  let types = ["0", "1"]

  // 未登录
  if (to.name !== 'login' && to.name !== 'u3d') {
    if (!access_token || types.indexOf(login_type) === -1) {
      router.push({ path: '/login' })
      return
    }
  }
  // 已登录
  else if (to.name === 'login') {
    if (access_token && types.indexOf(login_type) !== -1) {
      if (login_type === '0') {
        router.push({ path: '/teacher' })
      } else if (login_type == '1') {
        router.push({ path: '/student/home' })
      }
      return
    }
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js